/**
 * GuidedTourMenuItem — entrée « Visite guidée » du menu compte (SAAS-1145).
 *
 * @remarks
 * Lance le tour `app-overview`. Le tour démarre au `onSelect`, donc après la
 * fermeture du dropdown : les ancres du rail et du header sont déjà là, et la
 * bulle driver.js ne se superpose pas au menu.
 */

import { Compass } from 'lucide-react';
import { DropdownMenuItem, Icon } from '@/shared/ui';
import { TOUR_IDS } from './tour-types';
import { useGuidedTour } from './use-guided-tour';

export function GuidedTourMenuItem() {
  const { startTour } = useGuidedTour();

  return (
    <DropdownMenuItem
      onSelect={() => {
        void startTour(TOUR_IDS.APP_OVERVIEW);
      }}
    >
      <Icon icon={Compass} size="md" />
      <span>Visite guidée</span>
    </DropdownMenuItem>
  );
}
